import { faCameraCircle } from '@fortawesome/pro-duotone-svg-icons'
import { Fragment, memo } from 'react'

import { isAndroid, isMobile, isSafari } from 'src/util/media.helpers'
import { LABEL_TEXT } from '../../../constants/messages'
import { reloadWindow } from '../../../util/app/app.helpers'
import Popup from '../../shared/popup/Popup'
import TextLink from '../../shared/text/TextLink'

const CameraBlocked = ({ t, onCancel }) => {
  return (
    <Popup
      icon={faCameraCircle}
      title={t(LABEL_TEXT.QR_CAMERA_BLOCKED)}
      description={buildCameraBlockedMessage(t)}
      cancelLabel={t(LABEL_TEXT.DISMISS)}
      onCancel={onCancel}
    />
  )
}

export default memo(CameraBlocked)

const buildCameraBlockedMessage = (t) => {
  const qrScannerRequiresText = t(LABEL_TEXT.QR_SCANNER_REQUIRES_CAMERA)
  if (isMobile()) {
    if (isAndroid()) {
      return (
        <Fragment>
          {qrScannerRequiresText} {t(LABEL_TEXT.CAMERA_BLOCKED_ANDROID_CHROME)}{' '}
          {buildRefreshText(t)}
        </Fragment>
      )
    }
    return (
      <Fragment>
        {qrScannerRequiresText}{' '}
        {
          <Fragment>
            {t(LABEL_TEXT.PLEASE)} {refreshLink(t)}{' '}
            {t(LABEL_TEXT.QR_TO_ACCESS_CAMERA)}
          </Fragment>
        }
      </Fragment>
    )
  } else {
    if (isSafari()) {
      return (
        <Fragment>
          {qrScannerRequiresText} {t(LABEL_TEXT.CAMERA_BLOCKED_SAFARI)}{' '}
          {buildRefreshText(t)}
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          {qrScannerRequiresText} {t(LABEL_TEXT.CAMERA_BLOCKED)}
        </Fragment>
      )
    }
  }
}

const buildRefreshText = (t) => {
  return (
    <Fragment>
      {t(LABEL_TEXT.AND_THEN)} {refreshLink(t)}
    </Fragment>
  )
}

const refreshLink = (t) => {
  return <TextLink onClick={reloadWindow} label={t(LABEL_TEXT.REFRESH)} />
}
